import axios from "axios";
import API from "../_helpers/endpointService";

export const getprojectcorrectdocinfo = (data, id) => {
  let apiUrl = API.CORRECTIVE_ACTIONS + id + '?Name=' + data.Name + '&Top=' +data.Top + '&PageNo=' + data.PageNo + '&PageSize=' + data.PageSize
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
      // data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "CORRECTIVE_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const addcorrectdocumentinfo = (data, id, modify) => {
  let apiUrl = API.CORRECTIVE_ACTIONS + id + '?modify=' + modify
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({type:"CORRECTIVE_UPLOAD",data:[]});
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const deletemuliticorrectdocs = (data,id) => {
  let ids = "";
  if(data && data.length > 0){
       data.map((val, index) => {
          if ( index == 0){
          ids += "ids=" + val.data;
          }
          else
          {
          ids += "&ids=" + val.data;
          }
      })
  }  
  let apiUrl = API.CORRECTIVE_ACTIONS + 'ids?' + ids ;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "delete",
      url: apiUrl,
      // data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
       dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const downloadsinglecorrectdocs = (data) => {
  let apiUrl = API.CORRECTIVE_ACTIONS + data.DocumentId + '/Download';
  return (dispatch) => {
 dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "get",
      url: apiUrl,
      responseType: "blob",
      // data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false})
        if (response?.status === 200) {
          let blob = new Blob([response.data]);
          let url = URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = data.DocumentName;
          a.click();
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const downloadmultiplecorrectdocs = (data) => {
  let keys = "";
  if(data && data.length > 0){
       data.map((val, index) => {
          if ( index == 0){
          keys += "keys=" + val.objectkey;
          }
          else
          {
          keys += "&keys=" + val.objectkey;
          }
      })
  }
  let apiUrl = API.CORRECTIVE_ACTIONS  + 'keys?' + keys;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "get",
      url: apiUrl,
      responseType: "blob",
      // data: data,
      // headers : {
      //   'content-type': 'application/json'
      // }
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          let blob = new Blob([response.data]);
          let url = URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = "CorrectiveActions.zip"
          a.click();
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};

export const gethistorylogcorrectdocinfo = (id) => {
  let apiUrl = API.HISTORY_LOG + id + '?name=CorrectiveAction'
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
      // data: data,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "HISTORY_LOG", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};